import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Badge from '@material-ui/core/Badge';
import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
export const AvatarDiv = lib.styled(Avatar)`
  position: relative;
  width: 50px;
  height: 50px;
  padding: 0px!important;
`;
export const PersonIconDiv = lib.styled(PersonIcon)`

`;
export const BoxHeader = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
`;
export const ArrowDropDownDiv = lib.styled(ArrowDropDown)``;
export const IconButtonDiv = lib.styled(IconButton)`
  position: relative;
  width: 50px;
  height: 50px;
  padding: 0px!important;

  &:hover: {
      background-color: ${colors.lightGray};
  };
`;
export const MenuItemDiv = lib.styled(MenuItem)``;
export const MenuDiv = lib.styled(Menu)``;
export const BadgeDiv = lib.styled(Badge)`
  .badge{
    background-color: ${props => props.color};
    top: 42px;
    right: 12px;
    width: 14px;
    min-width: 14px!important;
    height: 14px;
    border: 2px solid white;
  }
`;
export const UserDiv = lib.styled.div`
  align-self: center;
  color: #364150;
  & p:nth-child(1): {
      font-size: 15;
      font-weight: 500;
  }
`;
export const SubUserDiv = lib.styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    & p:nth-child(1): {
      font-size: 12px;
      font-weight: 200;
    };
`;
